import Line from '@FreeRider/Track/Lines/Line';

class SceneryLine extends Line
{
    // Nothing here
}

export default SceneryLine;